import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";

import {
  getUserLocations,
  getMiniProductList,
} from "../../../store/Mini/actions";
import {
  getSRTimelLinereportslist,
  SRTimelLinereportslistSuccessful,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
} from "../../../store/Reports/actions";

const date = new Date();
const y = date.getFullYear();
const m = date.getMonth();

class SRTimelLineReports extends Component {
  constructor(props) {
    super(props);
    this.ReportsChangeHandeler = this.ReportsChangeHandeler.bind(this);
  }

  componentDidMount() {
    this.props.getUserLocations();
    this.props.SetParams({});
  }

  ReportsChangeHandeler(e) {
    this.props.ReportsChangeValue({
      key: e.target.name,
      value: e.target.value,
    });

    if (this.props.reportType === "document") {
      this.props.getSRTimelLinereportslist({
        ...this.props.params,
        [e.target.name]: e.target.value,
      });
    }
  }

  SelecteChangeValue({ key, label, key2, value }) {
    this.props.ReportsSelecteChangeValue({
      key,
      label,
      key2,
      value,
    });

    if (key2 === "location" || this.props.reportType === "document") {
      this.props.getSRTimelLinereportslist({
        ...this.props.params,
        [key2]: value,
        start_date:
          this.props.params.start_date ||
          moment(new Date(y, m, 1)).format("YYYY-MM-DD"),
        end_date:
          this.props.params.end_date || moment(new Date()).format("YYYY-MM-DD"),
      });
    }
  }

  reportType(e) {
    this.props.reportTypeCheck({ value: e.target.value });
    this.props.SRTimelLinereportslistSuccessful([]);

    if (e.target.value === "document") {
      this.props.getSRTimelLinereportslist({
        ...this.props.params,
        start_date:
          this.props.params.start_date ||
          moment(new Date(y, m, 1)).format("YYYY-MM-DD"),
        end_date:
          this.props.params.end_date || moment(new Date()).format("YYYY-MM-DD"),
      });
    }
  }

  render() {
    /** ---------- LOCATION SELECT ---------- */
    const locationOptions =
      this.props.userLocation?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || [];

    const selectedLocation =
      locationOptions.find(
        (opt) => opt.value === this.props.params?.location
      ) || null;

    /** ---------- MR CODE SELECT ---------- */
    const mrCodeOptions =
      this.props.SRQ_REPORTS_LIST?.map((item) => ({
        label: item.mr_no,
        value: item.id,
      })) || [];

    const selectedMRCode =
      mrCodeOptions.find((opt) => opt.value === this.props.params?.id) || null;

    return (
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <Link to="/reports" className="action-icon text-primary mr-2">
                    <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20" />
                  </Link>
                  <h5 className="card-title-18 pt-2 d-inline-block">
                    SR TIMELINE REPORT
                  </h5>
                </CardHeader>

                <CardBody>
                  <Row>
                    {/* From Date */}
                    <Col md={3}>
                      <FormGroup>
                        <Label>From Date</Label>
                        <Input
                          type="date"
                          name="start_date"
                          value={
                            this.props.params.start_date ||
                            moment(new Date(y, m, 1)).format("YYYY-MM-DD")
                          }
                          onChange={this.ReportsChangeHandeler}
                          max={moment().format("YYYY-MM-DD")}
                        />
                      </FormGroup>
                    </Col>

                    {/* To Date */}
                    <Col md={3}>
                      <FormGroup>
                        <Label>To Date</Label>
                        <Input
                          type="date"
                          name="end_date"
                          value={
                            this.props.params.end_date ||
                            moment().format("YYYY-MM-DD")
                          }
                          onChange={this.ReportsChangeHandeler}
                          min={
                            this.props.params.start_date ||
                            moment(new Date(y, m, 1)).format("YYYY-MM-DD")
                          }
                          max={moment().format("YYYY-MM-DD")}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      <FormGroup className="mb-0">
                        <Label
                          htmlFor="mritems__product"
                          className="col-form-label"
                        >
                          Products :
                        </Label>

                        <Select
                          id="mritems__product"
                          name="mritems__product"
                          classNamePrefix="select2-selection"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={
                            this.props.miniProductList?.results?.map(
                              (item) => ({
                                label: `${item.name} - ${item.code}`,
                                value: item.id,
                              })
                            ) || []
                          }
                          /* 🔍 Search */
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") {
                              this.props.getMiniProductList({
                                ...this.props.miniProductParams,
                                page: 1,
                                page_size: 10,
                                search: inputValue,
                              });
                            }
                          }}
                          /* 📂 Initial load */
                          onMenuOpen={() => {
                            this.props.getMiniProductList({
                              ...this.props.miniProductParams,
                              page: 1,
                              page_size: 10,
                              search: "",
                            });
                          }}
                          /* ⬇ Pagination */
                          onMenuScrollToBottom={() => {
                            if (
                              this.props.miniProductParams.page <
                              this.props.miniProductParams.no_of_pages
                            ) {
                              this.props.getMiniProductList({
                                ...this.props.miniProductParams,
                                page: this.props.miniProductParams.page + 1,
                                page_size: 10,
                              });
                            }
                          }}
                          /* ✅ Correct value binding */
                          value={
                            this.props.params?.mritems__product
                              ? {
                                  label:
                                    this.props.miniProductList?.results?.find(
                                      (p) =>
                                        p.id ===
                                        this.props.params.mritems__product
                                    )?.name,
                                  value: this.props.params.mritems__product,
                                }
                              : null
                          }
                          /* ✅ Correct change handler */
                          onChange={(e) => {
                            this.props.ReportsSelecteChangeValue({
                              key: "mritems__product_label",
                              label: e?.label,
                              key2: "mritems__product",
                              value: e?.value,
                            });

                            if (this.props.reportType === "document") {
                              this.props.getSRTimelLinereportslist({
                                ...this.props.params,
                                mritems__product: e?.value,
                                start_date:
                                  this.props.params.start_date ||
                                  moment(new Date(y, m, 1)).format(
                                    "YYYY-MM-DD"
                                  ),
                                end_date:
                                  this.props.params.end_date ||
                                  moment().format("YYYY-MM-DD"),
                              });
                            }
                          }}
                          isClearable
                          placeholder="Select Product"
                        />
                      </FormGroup>
                    </Col>

                    {/* Location */}
                    <Col md={3}>
                      <FormGroup>
                        <Label>Locations</Label>
                        <Select
                          options={locationOptions}
                          value={selectedLocation}
                          onChange={(e) =>
                            this.SelecteChangeValue({
                              key: "locationlabel",
                              label: e?.label,
                              key2: "location",
                              value: e?.value,
                            })
                          }
                          isClearable
                          placeholder="Select Location"
                        />
                      </FormGroup>
                    </Col>

                    {/* Report Type */}
                    <Col md={3} className="text-center">
                      <Label className="d-block">&nbsp;</Label>

                      <div className="border p-2 d-flex justify-content-center gap-4">
                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="reportType"
                              value="list"
                              checked={this.props.reportType === "list"}
                              onChange={(e) => this.reportType(e)}
                            />{" "}
                            List
                          </Label>
                        </FormGroup>

                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="reportType"
                              value="document"
                              checked={this.props.reportType === "document"}
                              onChange={(e) => this.reportType(e)}
                            />{" "}
                            Document
                          </Label>
                        </FormGroup>
                      </div>
                    </Col>

                    {/* MR Code */}
                    {this.props.reportType === "document" && (
                      <Col md={3}>
                        <FormGroup>
                          <Label>SR Code</Label>
                          <Select
                            options={mrCodeOptions}
                            value={selectedMRCode}
                            onChange={(e) =>
                              this.SelecteChangeValue({
                                key: "MRCodelabel",
                                label: e?.label,
                                key2: "id",
                                value: e?.value,
                              })
                            }
                            isClearable
                            placeholder="Select MR Code"
                          />
                        </FormGroup>
                      </Col>
                    )}
                  </Row>

                  {/* Generate Button */}
                  <Row>
                    <Col md={12} className="text-right">
                      {this.props.reportType === "document" ? (
                        <Link
                          to={`/srtimelinereportdoc/${this.props.params.id}`}
                        >
                          <Button
                            color="primary"
                            disabled={!this.props.params.id}
                          >
                            Generate Report
                          </Button>
                        </Link>
                      ) : (
                        <Link to="/srtimelinereportlist">
                          <Button color="primary">Generate Report</Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { userLocation, miniProductList, miniProductParams } = state.Mini;
  const { params, reportType, SRTimeLine_Doc_report, SRQ_REPORTS_LIST } =
    state.reports;

  return {
    userLocation,
    reportType,
    params,
    SRTimeLine_Doc_report,
    SRQ_REPORTS_LIST,
    miniProductList,
    miniProductParams,
  };
};

export default connect(mapStateToProps, {
  getUserLocations,
  getSRTimelLinereportslist,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
  SRTimelLinereportslistSuccessful,
  getMiniProductList,
})(SRTimelLineReports);
